import { useAppSelector } from "../hooks";

export const useCurrentAuction = () => {
  const currentAuction = useAppSelector((state) => state.auction.activeAuction);
  return currentAuction;
};
